export const Monad = Object.freeze({
	/** Monad m => m a ~> (a -> m a) -> m a */
	pure: (promote, value) => promote(value),
	/** Monad m => m a ~> (a -> b) -> b */
	fold: (fn, value) => fn(value),
	/** Monad m => m a ~> (a -> m b) -> m b */
	chain: (fn, value) => fn(value),
	/** Monad m => m a ~> (a -> b) -> m b */
	map: (promote, fn, value) => Monad.pure(promote, fn(value)),
});

export const Option = (value) =>
	value === null || value === undefined ? None() : Some(value);

export const Some = (value) => {
	return Object.freeze({
		/** (a -> Option a) -> Option a */
		pure: (value) => Monad.pure(Option, value),
		/** (a -> b) -> b */
		fold: (fn) => Monad.fold(fn, value),
		/** (a -> Option b) -> Option b */
		chain: (fn) => Monad.chain(fn, value),
		/** (a -> b) -> Option b */
		map: (fn) => Monad.map(Option, fn, value),
	});
};

export const None = () => {
	return Object.freeze({
		/** (a -> Option a) -> Option a */
		pure: (value) => Monad.pure(Option, value),
		/** (a -> b) -> b */
		fold: (fn) => undefined,
		/** (a -> Option b) -> Option b */
		chain: (fn) => None(),
		/** (a -> b) -> Option b */
		map: (fn) => None(),
	});
};

export const Try = (fn, ...args) => {
	try {
		return Right(fn(...args));
	} catch (error) {
		return Left(error);
	}
};

export const Right = (value) => {
	return Object.freeze({
		/** (A -> Right B) -> Right B */
		pure: (value) => Monad.pure(Right, value),
		/** (a -> b) -> b */
		fold: (fn) => Monad.fold(fn, value),
		/** (a -> Either b) -> Either b */
		chain: (fn) => Monad.chain(fn, value),
		/** (a -> Either a | b) -> Either a | b */
		map: (fn) => Try(fn, value),
		match: (pattern) => pattern.right(value),
	});
};

export const Left = (value) => {
	return Object.freeze({
		/** (A -> Left A) -> Left A */
		pure: (value) => Monad.pure(Left, value),
		/** (a -> b) -> b */
		fold: (fn) => Monad.fold(fn, value),
		/** (a -> Either b) -> Either b */
		chain: (fn) => Monad.chain(fn, value),
		/** (a -> Either a | b) -> Either a | b */
		map: () => Left(value),
		match: (pattern) => pattern.left(value),
	});
};
